// @flow

import type {
  FieldBorderOperationsById,
} from 'fc-operator-fieldborder/types'

import {
  TREE,
  UPLOAD_OPERATIONS_BRANCH,
} from '../constants'

import traverse from 'fc-utils/traverse'

type FieldBorderOperationsSelector = (state: Object) => FieldBorderOperationsById

export default (traverse([TREE, UPLOAD_OPERATIONS_BRANCH]): FieldBorderOperationsSelector)
